package com.vamvisions.main.portfolio.presentation.document

import com.vamvisions.main.core.presentation.i18n.UiText
import com.vamvisions.main.core.presentation.markdown.MdNode

/**
 * [title] and [content] are set once the document has loaded. [notFound] means the server has no such
 * document in the requested language; any other failure is an [error] the user can retry.
 */
data class DocumentState(
    val isLoading: Boolean = true,
    val title: String? = null,
    val content: List<MdNode> = emptyList(),
    val notFound: Boolean = false,
    val error: UiText? = null,
)
